/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LetterViewModel { 
    id?: string;
    datasetId?: string;
    letterName?: string | null;
    description?: string | null;
    includeSender?: boolean;
    includeRecipient?: boolean;
    includeBalance?: boolean;
    includePatientInfo?: boolean;
    message?: string | null;
    isDeleted?: boolean;
    deletedBy?: string | null;
    deletedDate?: string | null;
    createdBy?: string | null;
    createdDate?: string;
    updatedBy?: string | null;
    updatedDate?: string | null;
}

